module.exports = __webpack_public_path__ + "img/pIndex-shop.9c850629.jpg";